import type { LabelCategory, LabelStatus } from '../../api/labels'

export const labelCategoryLabels: Record<LabelCategory, string> = {
  genre: 'Genre',
  mood: 'Mood',
  use_case: 'Use case',
  instrument: 'Instrument',
  texture: 'Texture',
  rhythm: 'Rhythm',
  tempo: 'Tempo',
  energy: 'Energy',
  vocal_presence: 'Vocal presence',
  language: 'Language'
}

export const labelStatusLabels: Record<LabelStatus, string> = {
  active: 'Active',
  archived: 'Archived'
}

export const labelCategoryOptions = Object.keys(labelCategoryLabels) as LabelCategory[]
export const labelStatusOptions = Object.keys(labelStatusLabels) as LabelStatus[]
